import React, { useEffect, useState } from 'react';
import ChatbotBlockIcon from '../../layouts/tenant/ChatbotBlockIcon';
import ChatbotBlocks from '../../layouts/tenant/ChatbotBlocks';
import { bulkUpsertChatbotVariable, chatbotResponsesUpsert, getChatbotResponses, getChatbotVariable } from '../../store/actions/tenantAction';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { SHOW_SNACKBAR } from '../../utils/types';
import { CHATBOT_BLOCK_TYPES } from '../../utils/ChatbotBlockTypes';
import { getVariableComponent } from '../../utils/TemplateHelper';
import { Dropdown } from 'flowbite-react';
import PopUp from '../../components/PopUp';
import CopyChatbotBlock from '../../layouts/tenant/CopyChatbotBlock';

function NewChatbot({ setIsShow, isEdit, onAdd, selectedResponse }) {
    let dispatch = useDispatch();
    const { t } = useTranslation();
    const [allIntent, setAllIntent] = useState([]);
    const [variables, setVariables] = useState([]);
    const [response, setResponse] = useState({ responses: [], keywords: [], type: "text", actionType: "KEYWORD" });
    const globalReducer = useSelector((state) => state.globalReducer);
    const [Blocks, setBlocks] = useState([]);
    const [selectedBlock, setSelectedBlock] = useState({});
    const [showCopyChatbotBlock, setShowCopyChatbotBlock] = useState(false);

    useEffect(() => {
        getVariables();
        dispatch(getChatbotResponses(
            {
                select: ["id", "intentName"],
                tenantId: globalReducer.loginInfo?.tenantId,
                criteria: {
                    tenantWabaId: globalReducer.waba?.id,
                },
                count: true,
                size: 1000000,
                offset: 0,
                orderBy: [{ property: "id", direction: "DESC" }],
            },
            (d) => { setAllIntent(d?.data); }
        ));
        if (isEdit && selectedResponse) {
            if (selectedResponse?.intentName?.toLowerCase() === "default") {
                selectedResponse.actionType = "DEFAULT";
            }
            if (!selectedResponse?.keywords || selectedResponse?.keywords?.length === 0 || selectedResponse?.keywords[0] === "") {
                selectedResponse.actionType = "INTENT";
            }
            if (selectedResponse?.responses?.length > 0) {
                setBlocks(selectedResponse?.responses.map((r) => {
                    try {
                        if (r) {
                            if (r.startsWith("{")) {
                                const jp = JSON.parse(r);
                                if (!jp.type) {
                                    if (selectedResponse?.type === "buttons") {
                                        return { type: "buttons", interactive: { ...jp, type: "button" } };
                                    }
                                    return { type: selectedResponse?.type, [selectedResponse?.type]: jp };
                                }
                                return jp;
                            } else {
                                return { type: selectedResponse?.type ?? "text", text: r };
                            }
                        }
                    } catch (error) { return {}; }
                }));
            }
            setResponse({
                ...selectedResponse,
                responses: selectedResponse?.responses ?? [],
                keywords: selectedResponse?.keywords ?? [],
                detail: selectedResponse?.detail ?? {}
            });
        }
    }, []);

    const handleSubmit = async (e) => {
        e?.preventDefault();
        if (!isEdit) {
            response.tenantId = globalReducer.loginInfo?.tenantId;
            response.tenantWabaId = globalReducer.waba?.id;
        }
        await Promise.all(Blocks.filter(f => f.type === CHATBOT_BLOCK_TYPES.WHATSAPP_TEMPLATE).map(async (b) => {
            const componentsVal = await getVariableComponent(dispatch, globalReducer.loginInfo, globalReducer.waba, b?.template, b?.template?.carouselTemplate, true);
            if (componentsVal) {
                b.templateValue = { components: componentsVal };
            }
        }));
        response.responses = Blocks.filter(f => f).map((b) => JSON.stringify(b));
        if (!Array.isArray(response.responses) || response.responses?.length === 0) {
            dispatch({
                type: SHOW_SNACKBAR,
                payload: {
                    type: "success",
                    message: t("Please add at least one response"),
                    open: true,
                },
            });
            return;
        }
        upsertVariable();
        dispatch(chatbotResponsesUpsert(response, (a) => {
            if (e) { setIsShow(false); }
            onAdd(a);
        }));
    }

    const getVariables = () => {
        dispatch(getChatbotVariable({
            tenantId: globalReducer.loginInfo?.tenantId,
            criteria: {
                tenantWabaId: globalReducer.waba?.id,
            },
            size: 1000000,
            offset: 0,
        }, setVariables));
    }

    const upsertVariable = () => {
        const filteredVariables = variables.filter(f => !f.id);
        if (filteredVariables.length > 0) {
            dispatch(bulkUpsertChatbotVariable(filteredVariables.map(m => {
                return { ...m, tenantId: globalReducer.loginInfo?.tenantId, tenantWabaId: globalReducer.waba?.id }
            }), a => { }));
        }
    }

    function moveItem(array, fromIndex, toIndex) {
        const updated = [...array];
        const [movedItem] = updated.splice(fromIndex, 1);
        updated.splice(toIndex, 0, movedItem);
        return updated;
    }

    const moveUp = (index) => {
        if (index > 0) {
            setBlocks(moveItem(Blocks, index, index - 1));
        }
    };

    const moveDown = (index) => {
        if (index < Blocks.length - 1) {
            setBlocks(moveItem(Blocks, index, index + 1));
        }
    };

    const onEnterName = (e) => {
        let name = e.target.value?.toLowerCase()?.replace(/ /g, "_");
        const regex = /^[a-z][a-z0-9_]*$/;
        if (!name || regex.test(name)) {
            setResponse({ ...response, intentName: name });
        } else if (name) {
            setResponse({ ...response, intentName: name?.replace(e.nativeEvent.data, "") });
        }
    };
    const OnInput = (e) => e.target.value = e.target.value.slice(0, e.target.dataset.maxlength);
    return (<>
        <form className="height30 flex flex-col justify-between pb-3"
            onSubmit={handleSubmit}>
            <div className="h-dvh overflow-y-auto px-4 pb-1">
                <div className="grid grid-cols-1">
                    <div className="w-full">
                        <div className="text-gray-700 text-[14px] font-normal mb-1">
                            <label>{t("Rules that are connected to current sequence")}</label>
                        </div>
                        <div className="flex justify-between gap-4 mt-4">
                            <div>
                                <select required className="p-2 min-h-8 w-[150px] rounded-md border-gray-300" onChange={(e) => {
                                    response.actionType = e.target.value;
                                    if (e.target.value === "DEFAULT") {
                                        response.intentName = "default";
                                    } else {
                                        response.intentName = "";
                                    }
                                    setResponse({ ...response });
                                }} value={response?.actionType}>
                                    <option value="KEYWORD" selected>{t("Keyword")}</option>
                                    <option value="INTENT">{t("Intent")}</option>
                                    <option value="DEFAULT">{t("Default")}</option>
                                </select>
                            </div>
                            <div className="group relative w-full">
                                <input
                                    type="text" required
                                    disabled={response?.actionType === "DEFAULT"}
                                    placeholder={t("Enter intent Name")}
                                    value={response?.intentName}
                                    onChange={onEnterName}
                                    className="border border-gray-300 rounded-md py-2 text-[14px] w-full min-w-[280px]"
                                    data-maxlength={100}
                                    onInput={OnInput}
                                />
                                <div className="pointer-events-none absolute inset-y-0 right-0 rtl:left-2 flex items-center pr-2">
                                    <p className="text-xs bg-green-100 text-green-800 py-1 px-1 rounded">
                                        {response?.intentName?.length}/100
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {!["DEFAULT", "INTENT"].includes(response?.actionType) && (
                        <div className="col-span-12 border-t-2 border-theme mt-4">
                            <div className="text-gray-800 text-[13px] font-normal my-2 flex justify-between">
                                <label>{t("Keywords")}</label>
                                <button
                                    type="button"
                                    onClick={() => {
                                        if (!Array.isArray(response.keywords)) {
                                            response.keywords = [];
                                        }
                                        response.keywords.push("");
                                        setResponse({ ...response });
                                    }}
                                    className="px-2 py-1 whitespace-nowrap gap-2 bg-[#EEF2FF] flex items-center border rounded-md border-gray-300 hover:text-theme text-[12px] font-medium text-[#9D8CF8]"
                                >
                                    <i className="fa-solid fa-plus"></i>
                                    {t("Add")}
                                </button>
                            </div>
                            {response?.keywords?.map((b, i) => (
                                <div key={i} className="flex gap-2 w-full items-center">
                                    <div className="text-indigo-400">{`${i + 1}`}</div>
                                    <div className="group relative w-full h-fit m-[2px]">
                                        <input
                                            maxLength={250}
                                            type="text"
                                            value={b} required
                                            placeholder={`Type keyword for ${i + 1}`}
                                            className="border skipped w-full flex-grow border-gray-300 py-2 focus:border-none text-sm rounded-md bg-white"
                                            onChange={(e) => {
                                                response.keywords[i] = e.target.value?.toLowerCase();
                                                setResponse({ ...response });
                                            }}
                                        />
                                        <div className="pointer-events-none absolute inset-y-0 right-0 rtl:left-2 flex items-center pr-2">
                                            <p className="text-xs bg-green-100 text-green-800 py-1 px-1  rounded">
                                                {b?.length}/250
                                            </p>
                                        </div>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                response.keywords?.splice(i, 1);
                                                setResponse({ ...response });
                                            }}
                                            className="items-center justify-center whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 shadow absolute hidden group-hover:block top-[-8px] right-[-8px] hover:bg-red-500 hover:text-white h-fit rounded-full border text-[#374151] border-gray-300 bg-white p-0.5"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-x w-3.5 h-3.5 "
                                            >
                                                <path d="M18 6 6 18" />
                                                <path d="m6 6 12 12" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                    <div className='border-t-2 border-theme mt-4'>
                        <label className="py-1 text-[13px]">{t("Responses")}</label>
                        {Blocks?.map((m, i) => <div key={i} className='mt-2 flex'>
                            <div className='w-[25px] px-1'>
                                <button type='button' className='hover:bg-[#e4e8ef]' onClick={() => moveUp(i)}>
                                    <i className="fa-solid fa-arrow-up text-theme"></i>
                                </button>
                                <button type='button' className='hover:bg-[#e4e8ef]' onClick={() => moveDown(i)}>
                                    <i className="fa-solid fa-arrow-down text-theme"></i>
                                </button>
                            </div>
                            <div className='w-full bg-gray-50'>
                                <div className='border-t border-x border-gray-300 rounded-t-lg px-2 py-2'>
                                    <div className='flex justify-between'>
                                        <ChatbotBlockIcon type={m.type} onBlockSelect={() => { }} />
                                        <div className='flex items-center'>
                                            <button type='button' onClick={() => {
                                                Blocks.splice(i, 1);
                                                setBlocks([...Blocks]);
                                            }} className='hover:bg-gray-200 text-white px-3 py-2 rounded-lg'>
                                                <i className="fa-solid fa-trash-can text-theme"></i>
                                            </button>
                                            <div className='mr-2 border border-gray-300 rounded-lg px-2 py-3 text-[13px] text-gray-600'>
                                                <Dropdown inline arrowIcon={false} inputMode as="button"
                                                    className="font-medium text-[14px] text-gray-600 whitespace-nowrap hover:text-[#7A14FF] cursor-pointer bg-white"
                                                    label={<i className="fa-solid fa-ellipsis"></i>}>
                                                    <Dropdown.Item
                                                        className="hover:text-theme"
                                                        onClick={() => {
                                                            setShowCopyChatbotBlock(true);
                                                            setSelectedBlock({ ...m, copyType: "copy" });
                                                        }}>
                                                        <i className="fa-solid fa-copy pr-3"></i>
                                                        {t("Copy")}
                                                    </Dropdown.Item>
                                                    <Dropdown.Item
                                                        className="hover:text-theme"
                                                        onClick={() => {
                                                            setShowCopyChatbotBlock(true);
                                                            setSelectedBlock({ ...m, copyType: "move" });
                                                        }}>
                                                        <i className="fa-solid fa-circle-right pr-3"></i>
                                                        {t("Move")}
                                                    </Dropdown.Item>
                                                </Dropdown>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='min-h-[120px] border border-gray-300 rounded-b-lg p-2'>
                                    <ChatbotBlocks key={i} variables={variables} setVariables={setVariables} allIntent={allIntent} type={m.type} isEdit={isEdit} setBlocks={setBlocks} blockIndex={i} Blocks={Blocks} />
                                </div>
                            </div>
                        </div>)}
                        <div className='border-t border border-gray-300 bg-gray-50 rounded-lg mt-2 flex ml-6'>
                            <div className='bg-gray-200 py-2 px-5 rounded-lg shadow-md'>
                                <i className="fa-solid fa-plus text-[20px] pt-2 text-theme"></i>
                            </div>
                            <div className='px-2 py-2 ml-2'>
                                <ChatbotBlockIcon type={"all"} onBlockSelect={(blockType) => setBlocks([...Blocks, { type: blockType }])} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="h-[10vh] px-4 bg-white border-t-[1px] border-grayish relative">
                <div className="flex justify-end gap-2 my-2">
                    <button
                        type="button"
                        className="px-[16px] py-[6px] text-[#644d81] font-medium text-[14px] bg-[#ECF0F7] transition-all ease-in-out rounded cursor-pointer hover:bg-[#e4e8ef]"
                        onClick={() => setIsShow(false)}
                    >
                        {t("Cancel")}
                    </button>
                    <button
                        type="submit"
                        className="min-w-[76px] text-center px-[16px] py-[6px] text-white font-medium text-[14px] bg-theme transition-all ease-in-out rounded cursor-pointer hover:bg-primary"
                    >
                        {t("Save")}
                    </button>
                </div>
            </div>
        </form>
        <PopUp
            ModalHeader={
                <span className="font-medium text-[18px] text-black">
                    {selectedBlock?.copyType === "copy" ? t("Select a sequence to copy this block") : t("Select a sequence to move this block")}
                </span>
            }
            isShowModal={showCopyChatbotBlock}
            setIsShowModal={setShowCopyChatbotBlock}
            ModalBody={
                <CopyChatbotBlock setIsShow={setShowCopyChatbotBlock} onAdd={(q) => {
                    if (selectedBlock?.copyType === "move") {
                        Blocks?.splice(Blocks.indexOf(selectedBlock), 1);
                        setBlocks([...Blocks]);
                        handleSubmit();
                    } else {
                        onAdd(q);
                    }
                }} selectedBlock={selectedBlock} allIntent={allIntent} />
            }
            size="2xl"
        />
    </>)
}

export default NewChatbot